var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeydarAliyevCenterLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.395,
    height: 43.615,
    viewBox: "0 0 48.395 43.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M3.113,27.225C.5,24.835-.919,21.8.662,18.371a6.666,6.666,0,0,1,4.59-3.817c2.594-.542,7.257-.248,10.184-.472,9.56-.731,11.693-4.57,18.3-10.589,2.533-2.309,7.956-5.232,11.231-2.187,2.439,2.268,3.023,8.7,3.265,11.965.358,4.811.678,10.265-5.171,10.391L36.6,23.6l-6.457-.061s12.718-.119,12.914-.127c5.574-.237,5.069-5.5,4.6-10.086-.3-2.939-1.065-9.335-3.345-11.3C42.152.151,38.229,1.925,36.288,3.39,28.9,8.964,25.621,14.145,15.471,14.649c-2.9.144-7.6-.257-10.166.221A6.4,6.4,0,0,0,.834,18.452C-.795,21.8.59,24.826,3.113,27.225",
    transform: "translate(0 0.001)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M16.757,38.294c2.087-1.332,4.183.408,5.8,1.78,3.808,3.232,8.136,8.627,13.7,7.941,5.162-.636,7.813-7,9.906-11.264C47.89,33.227,52.812,23,57.554,23.911c4.159.8,3.878,11.614,3.8,14.864,0-2.982-.043-13.818-3.878-14.421-5.412-.85-9.421,12.03-11.516,15.973-2.053,3.865-5.265,8.371-10.194,8.422-5.656.059-9.5-5.121-13.32-8.547-1.566-1.4-3.587-3.177-5.689-1.908",
    transform: "translate(-14.875 -21.175)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M243.672,281.48v-.141c0-.826-.391-1.5-1.268-1.5a1.648,1.648,0,0,0-1.082.416l-.243-.384a1.946,1.946,0,0,1,1.377-.512c1.3,0,1.959.871,1.959,2.241a2.561,2.561,0,0,1-.6,1.837,1.6,1.6,0,0,1-1.191.48,1.53,1.53,0,0,1-1.146-.429,2.446,2.446,0,0,1-.519-1.9v-.115Zm-1.722,1.665a.856.856,0,0,0,.685.307c.691,0,1.031-.576,1.031-1.485h-2a1.8,1.8,0,0,0,.288,1.178",
    transform: "translate(-213.902 -247.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M283.866,284.457h-2.2v-4.411h.627v3.9h1.677Z",
    transform: "translate(-250.031 -248.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M308.92,270.617a.445.445,0,1,1,.429-.448.442.442,0,0,1-.429.448m-.288.269h.627V275.3h-.627Z",
    transform: "translate(-273.862 -239.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M323.2,282.7v1.754h-.64V282.69l-1.4-2.644h.756l.73,1.5a5.622,5.622,0,0,1,.243.57c.077-.179.16-.365.256-.563l.743-1.511h.717Z",
    transform: "translate(-285.093 -248.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M357.814,284.457v-4.411h2.4l-.083.506h-1.69V281.9h1.415v.518h-1.415v1.511h1.844v.531Z",
    transform: "translate(-317.629 -248.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M385.878,284.469h-.6l-1.473-4.424h.679l.845,2.657c.051.154.122.39.166.583.032.141.058.243.07.333h.038c.07-.288.16-.589.269-.922l.864-2.651h.64Z",
    transform: "translate(-340.7 -248.594)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M103.4,352.857l-.23-3c-.019-.237-.026-.589-.032-.717h-.013c-.026.128-.09.423-.16.659l-.877,3.06h-.531l-.807-2.919c-.1-.339-.166-.666-.2-.807h-.013c-.006.154-.026.576-.045.807l-.224,2.919h-.6l.4-4.411h.864l.743,2.708a6.884,6.884,0,0,1,.16.723h.013c.019-.109.07-.4.154-.691l.768-2.74h.871l.378,4.411Z",
    transform: "translate(-88.471 -309.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M149.4,349.881v-.141c0-.826-.391-1.5-1.268-1.5a1.648,1.648,0,0,0-1.082.416l-.243-.384a1.945,1.945,0,0,1,1.376-.512c1.3,0,1.959.871,1.959,2.241a2.562,2.562,0,0,1-.6,1.837,1.6,1.6,0,0,1-1.191.48,1.53,1.53,0,0,1-1.146-.429,2.446,2.446,0,0,1-.519-1.9v-.115Zm-1.722,1.665a.857.857,0,0,0,.685.307c.691,0,1.031-.576,1.031-1.485h-2a1.8,1.8,0,0,0,.288,1.178",
    transform: "translate(-130.214 -308.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M189.524,352.857c-.128-.25-.186-.352-.365-.653a5.992,5.992,0,0,0-.762-1.1.494.494,0,0,0-.4-.2v1.953h-.615v-4.411h1.236a1.427,1.427,0,0,1,1.044.32,1.212,1.212,0,0,1,.39.909,1.118,1.118,0,0,1-1.127,1.21h-.051a1.914,1.914,0,0,1,.384.41c.09.122.224.314.371.544l.64,1.018ZM189,349.035a1.477,1.477,0,0,0-.538-.083H188v1.537h.429a1.024,1.024,0,0,0,.762-.211.814.814,0,0,0,.218-.6.672.672,0,0,0-.41-.647",
    transform: "translate(-166.341 -309.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M221.073,348.446h.627v4.411h-.627Zm2.228,4.411-1.575-2.356,1.543-2.055h.775l-1.613,2.049,1.671,2.362Z",
    transform: "translate(-196.245 -309.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M254.618,349.881v-.141c0-.826-.39-1.5-1.268-1.5a1.648,1.648,0,0,0-1.082.416l-.243-.384a1.946,1.946,0,0,1,1.377-.512c1.3,0,1.959.871,1.959,2.241a2.562,2.562,0,0,1-.6,1.837,1.6,1.6,0,0,1-1.191.48,1.53,1.53,0,0,1-1.146-.429,2.446,2.446,0,0,1-.519-1.9v-.115Zm-1.722,1.665a.856.856,0,0,0,.685.307c.691,0,1.031-.576,1.031-1.485h-2a1.8,1.8,0,0,0,.288,1.178",
    transform: "translate(-223.619 -308.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M291.534,352.857H288.9v-.474l1.78-2.99a4.269,4.269,0,0,1,.314-.455c-.128.013-.288.019-.506.019H288.98l.147-.512h2.535v.493l-1.761,2.99c-.1.166-.2.294-.275.422.134-.006.282-.006.442-.006h1.62Z",
    transform: "translate(-256.457 -309.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M322.146,339.017a.445.445,0,1,1,.429-.448.441.441,0,0,1-.429.448m-.288.269h.627V343.7h-.627Z",
    transform: "translate(-285.602 -300.153)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M21.873,284.457v-2.094H20.189v2.094h-.608v-4.411h.608v1.812h1.684v-1.812h.621v4.411Z",
    transform: "translate(-17.382 -248.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M57.2,284.457v-4.411h2.4l-.083.506h-1.69V281.9h1.415v.518H57.827v1.511h1.844v.531Z",
    transform: "translate(-50.776 -248.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M84.085,282.7v1.754h-.64V282.69l-1.4-2.644H82.8l.73,1.5a5.655,5.655,0,0,1,.243.57c.077-.179.16-.365.256-.563l.743-1.511h.717Z",
    transform: "translate(-72.834 -248.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M121.287,283.862a1.69,1.69,0,0,1-1.485.6h-1.1v-4.411h1.024a1.781,1.781,0,0,1,1.652.73,2.96,2.96,0,0,1-.09,3.086m-.531-2.932a1.017,1.017,0,0,0-.928-.391h-.5v3.412h.487a1.035,1.035,0,0,0,1.031-.493,2.4,2.4,0,0,0,.237-1.127,2.2,2.2,0,0,0-.326-1.4",
    transform: "translate(-105.37 -248.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M156.863,281.48v-.141c0-.826-.391-1.5-1.268-1.5a1.648,1.648,0,0,0-1.082.416l-.243-.384a1.945,1.945,0,0,1,1.376-.512c1.3,0,1.959.871,1.959,2.241a2.562,2.562,0,0,1-.6,1.837,1.6,1.6,0,0,1-1.191.48,1.53,1.53,0,0,1-1.146-.429,2.446,2.446,0,0,1-.519-1.9v-.115Zm-1.722,1.665a.857.857,0,0,0,.685.307c.691,0,1.031-.576,1.031-1.485h-2a1.8,1.8,0,0,0,.288,1.178",
    transform: "translate(-136.842 -247.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M196.991,284.456c-.128-.25-.186-.352-.365-.653a5.993,5.993,0,0,0-.762-1.1.494.494,0,0,0-.4-.2v1.953h-.615v-4.411h1.236a1.427,1.427,0,0,1,1.044.32,1.212,1.212,0,0,1,.39.909,1.119,1.119,0,0,1-1.127,1.21h-.051a1.913,1.913,0,0,1,.384.41c.09.122.224.314.371.544l.64,1.018Zm-.525-3.822a1.477,1.477,0,0,0-.538-.083h-.461v1.537h.429a1.024,1.024,0,0,0,.762-.211.814.814,0,0,0,.218-.6.672.672,0,0,0-.41-.647",
    transform: "translate(-172.969 -248.594)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeydarAliyevCenterLogoWhite);
export default __webpack_public_path__ + "static/media/heydar_aliyev_center_logo_white.32f42e03f1ab04f05e94cc996a351b7e.svg";
export { ForwardRef as ReactComponent };